import React from "react";

import styles from "../../../../../styles/add-product.module.scss";

import { Hairline } from "../../../../components/Hairline";
import { Input } from "../../../../components/Input";
import { Label } from "../../../../components/Label";

export default class SetDrinkSizesStepChild extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      product: props.product,
      onChange: props.onChange || {},
    };
  }

  render() {
    return (
      <>
        {
          this.state.category.sizes.map((size, index) => {
            return (
              <div key={index}>
                <Label>Qual é o valor para o item?</Label>
                <div className="d-flex mb-20">
                  <div className={styles.sizeName}>{size.name}</div>
                  <Input
                    design="four"
                    placeholder="R$ 0,00"
                    className="w-50"
                    id={index.toString()}
                    onChange={(e) => { this.state.onChange(e.target.value, index) }}
                  />
                </div>
                {
                  (index < this.state.category.sizes.length - 1) &&
                  <Hairline className="mt-20 mb-20" />
                }
              </div>
            )
          })
        }
      </>
    );
  }
}
